import DropDown from 'components/UI/DropDown';
import Radio from 'components/UI/Radio';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SortOption } from './productSort';
import './SortDropdown.scss';
function SortDropdown({ defaultSortBy, onChangeSort }) {
    const sortOptions = [
        SortOption.recommended,
        SortOption.name,
        SortOption.dateDesc,
        SortOption.priceDesc,
        SortOption.priceAsc,
    ];
    const [selected, setSelected] = useState(defaultSortBy);
    const [isExpanded, setIsExpanded] = useState(false);
    const { t } = useTranslation();
    return (React.createElement(DropDown, { title: t('productProductFilterSort'), expanded: isExpanded, className: "sort-dropdown", onClose: () => setIsExpanded(false), onClick: () => setIsExpanded(!isExpanded) }, sortOptions.map((tag, index) => {
        return (React.createElement(Radio, { className: "sort-dropdown__option", onChange: (e) => {
                const newSort = e.target.value;
                setSelected(newSort);
                onChangeSort(newSort);
            }, group: "productSort", id: `sort-${index}`, key: index, value: tag, defaultChecked: tag === selected }, t('productSortBy_' + tag)));
    })));
}
export default SortDropdown;
